import React from 'react';
import {Link} from 'react-router-dom';
import {
    AltButtonStyled,
    AltLightButtonStyled,
    SecondaryLightButtonStyled,
    SecondaryButtonStyled,
    CheckoutButtonStyled,
    JobButtonStyled,
    PrimaryButtonStyled
} from "../../../styled/Buttons";
import {useTheme} from "../Theme/ThemeContext";
import {useDispatch} from "react-redux";
import {setError} from "../../../redux/states";


const Button = (props) => {

    const dispatch = useDispatch();

    const {themeName} = useTheme();
    const {
        $checkout,
        title,
        width,
        $pricing,
        color,
        $radius,
        $border,
        clickHandle,
        target,
        justifycontent,
        link,
        children,
        $bg,
        $pad,
        $premium,
        $borderColor,
        $reccomended,
        checkoutHandle,
        $job,
        jobHandler,
        $right,
        disabled,
        primary,
        secondary,
        alternate,
        alternateLight,
        secondaryLight
    } = props;

    return (
        <>
            { primary &&
                <PrimaryButtonStyled
                    to={link}
                    width={width}
                    $pricing={$pricing}
                    justifycontent={justifycontent}
                    theme={themeName}
                    color={color}
                    $radius={$radius}
                    $border={$border}
                    $bg={$bg}
                    disabled={disabled}
                >
                    <Link to={link && link} onClick={clickHandle} target={target}>
                        {title}
                        {children}
                    </Link>
                </PrimaryButtonStyled>
            }
            { secondary &&
                <SecondaryButtonStyled
                    to={link}
                    width={width}
                    color={color}
                    $radius={$radius}
                    $border={$border}
                    $bg={$bg}
                    disabled={disabled}
                >
                    <Link to={link} onClick={clickHandle} target={target}>
                        {title}
                        {children}
                    </Link>
                </SecondaryButtonStyled>
            }

            {
                secondaryLight &&
                <SecondaryLightButtonStyled
                    to={link}
                    width={width}
                    $pricing={$pricing}
                    justifycontent={justifycontent}
                    theme={themeName}
                    color={color}
                    $borderColor={$borderColor}
                    $radius={$radius}
                    $border={$border}
                    $bg={$bg}
                    $pad={$pad}
                    disabled={disabled}
                >
                    <Link to={link} onClick={clickHandle} target={target}>
                        {title}
                        {children}
                    </Link>
                </SecondaryLightButtonStyled>
            }

            { alternate &&
                <AltButtonStyled
                    to={link}
                    width={width}
                    $pricing={$pricing}
                    theme={themeName}
                    color={color}
                    $radius={$radius}
                    $border={$border}
                    $bg={$bg}
                    $pad={$pad}
                    disabled={disabled}
                >
                    <Link to={link} onClick={clickHandle} target={target}>
                        {title}
                        {children}
                    </Link>
                </AltButtonStyled>
            }

            {
                alternateLight &&
                <AltLightButtonStyled
                    to={link}
                    width={width}
                    $pricing={$pricing}
                    theme={themeName}
                    color={color}
                    $radius={$radius}
                    $border={$border}
                    $bg={$bg}
                    $pad={$pad}
                    disabled={disabled}
                >
                    <Link to={link} onClick={clickHandle} target={target}>
                        {title}
                        {children}
                    </Link>
                </AltLightButtonStyled>
            }


            { $checkout === 'true' &&
                <CheckoutButtonStyled onClick={checkoutHandle} $reccomended={$reccomended} $borderColor={$borderColor} color={color} $bg={$bg} width={width} $premium={$premium} disabled={disabled}>
                    {title}
                    {children}
                </CheckoutButtonStyled>
            }

            { $reccomended === 'true' &&
                <CheckoutButtonStyled onClick={checkoutHandle} $reccomended={$reccomended} $borderColor={$borderColor} color={color} $bg={$bg} width={width} $premium={$premium} disabled={disabled}>
                    {title}
                    {children}
                </CheckoutButtonStyled>
            }


            {$job === 'true' &&
                <JobButtonStyled to={link} theme={themeName} $border={$border} color={color} width={width} $bg={$bg} $radius={$radius} $right={$right} disabled={disabled}>
                    <Link to={link} onClick={jobHandler}>
                        {title}
                        {children}
                    </Link>
                </JobButtonStyled>

            }
        </>

    );
}


export default Button;